// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ChangePasswordRequestModel {
    static getAttributeTypeMap() {
        return ChangePasswordRequestModel.attributeTypeMap;
    }
}
ChangePasswordRequestModel.discriminator = undefined;
ChangePasswordRequestModel.attributeTypeMap = [
    {
        "name": "oldPassword",
        "baseName": "oldPassword",
        "type": "string"
    },
    {
        "name": "newPassword",
        "baseName": "newPassword",
        "type": "string"
    }
];
//# sourceMappingURL=changePasswordRequestModel.js.map